module.exports = __webpack_public_path__ + "static/demo-id-company-e53d4eb2f6365748d4908bed2eaf7ac6.png";